import type { UserRole } from '@/types/types';

export function getDefaultPathForRole(role?: UserRole | null): string {
  switch (role) {
    case 'SYSADMIN':
      return '/admin';
    case 'ADMIN':
      return '/dashboard';
    case 'ASESOR':
    default:
      return '/';
  }
}
